import { Component, Inject } from '@angular/core';
import { Node } from '../../../../../../../../types/src/node'; import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NodeService } from '../node.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ErrorDialogComponent } from '../../../shared/dialogs/error-dialog.component';
import { Rule } from '@aptsi-types';
import { RuleService } from 'src/app/features/ada-access/rules/rules.service';
import { SuccessDialogComponent } from '../../../shared/dialogs/success-dialog/success-dialog.component';

@Component({
  selector: 'app-node-update',
  templateUrl: './node-update.component.html',
  styleUrls: ['./node-update.component.scss']
})
export class NodeUpdateComponent {
  isCreate = false;
  existingNodeId: string = null;
  nodes: Node = null;
  form: FormGroup;
  existingRulesetId: string = null;
  filteredDataToSearch: any[] = [];
  rule: Rule[] = [];
  nullver: number=null;
  isCredAttribute: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private nodeService: NodeService,
    private ruleService: RuleService
  ) { }

  async ngOnInit(): Promise<void> {

    this.fetchRules().then(() => {
      this.filteredDataToSearch = this.rule.map(w => {
        return {
          text: w.name,
          value: w.ruleid
        };
      });
    });


    this.isCreate = Boolean(this.route.snapshot.data.create);
    this.existingNodeId =  this.route.snapshot.params.nodeId;
    this.existingRulesetId =  this.route.snapshot.params.existingRulesetId;

    if (!this.isCreate) {
      this.fetchNode();

    }

    this.form = this.isCreate ? new FormGroup({
      //nodeId: new FormControl(null, Validators.required),
      rulesetId: new FormControl(this.existingRulesetId, Validators.required),
      ruleId: new FormControl(null, Validators.required),
      childId: new FormControl(null, Validators.required),
      parentId: new FormControl(null, Validators.required)

    }) : new FormGroup({
      nodeId: new FormControl(this.existingNodeId, Validators.required),
      ruleId: new FormControl(this.nodes ? this.nodes.ruleId : null, Validators.required),
      childId: new FormControl(this.nodes ? this.nodes.childId : null, Validators.required),
      parentId: new FormControl(this.nodes ? this.nodes.parentId : null, Validators.required)

    });
   
  }


  openDropdown(){
    
      this.fetchRules().then(() => {
        this.filteredDataToSearch = this.rule.map(w => {
          return {
            text: w.name,
            value: w.ruleid
          };
        });
      });
    
  }
   
  lookup(e) {
    this.filteredDataToSearch = this.rule
      .filter(
        i =>
          (i.name)
            .toString()
            .toLowerCase()
            .indexOf(e) > -1
      )
      .map(w => {
        return {
          text: w.name,
          value: w.ruleid
        };
      });
  }

  clean(t){
    t.value = '';
    this.lookup(t.value);
  }

  async fetchNode() {
    try {
      const response = await this.nodeService.getNodeByNodeId(this.existingNodeId).toPromise();

      this.nodes = response['Resource retrieved successfully.'] ? response['Resource retrieved successfully.'][0] : null;
      if (this.nodes) {
        this.form.patchValue({
          ruleId: this.nodes.ruleId,
          childId: this.nodes.childId,
          parentId: this.nodes.parentId
        });

      }
      console.log(this.nodes);
    } catch (error) {
      console.error("Error fetching rulesets:", error);
    }
  }

  cancel() {
    this.router.navigate(['ada-access/auth-tools/policy-authoring/ruleset/search']);
  }

  async fetchRules() {
    try {
      const response = await this.ruleService.getAllRules(this.nullver).toPromise();
      this.rule = response['Resource retrieved successfully'] || [];
      this.rule.sort((a, b) => a.rulesetid - b.rulesetid);
    } catch (error) {
      console.error("Error fetching rulesets:", error);
    }
  }

  redirectToRuleCreate() {
    this.router.navigate(['ada-access/auth-tools/policy-authoring/rule/create'])
  }
 
  openCredentialInfo(){
    this.isCredAttribute=!this.isCredAttribute;
  }

  // async add() {
  //     this.loading = true;
      
  //       setTimeout(() => {
  //         try {
  //           const dialogRef = this.dialog.open(configurationPopupDialogComponent, {
  //             data: {
  //               title: "Select Adaptive Access Nodes",
  //               message: "The rule has been deleted successfully.",
  //               existingAssetSourceId: `${this.form.value.assetsourceId}`,
  //             },
  //             width: "800px",
  //           });
    
  //           this.isTableVisible = true;
    
  //           // When the dialog closes, reset the specific form fields
  //           dialogRef.afterClosed().subscribe(() => {
  //             this.form.patchValue({
  //               credentialAttributeName: null,
  //               credentialAttributeValue: null,       
  //             });
  //             this.loading = false; // Hide the spinner when done
  //             this.isCredAttribute=!this.isCredAttribute;
  //           });
  //         } catch (error) {
  //           console.error("Error opening dialog:", error);
  //           this.loading = false; // Hide the spinner on error
  //         }
  //       }, 1000); // Keeping the 3-second delay as per original code
      
  //   }



    // viewDetails(){
    //   const dialogRef = this.dialog.open(configurationPopupDialogComponent, {
    //     data: {
    //       title: "Select Adaptive Access Nodes",
    //       message: "The rule has been deleted successfully.",
    //       existingAssetSourceId: `${this.form.value.assetsourceId}`,
    //     },
    //     width: "800px",
    //   });
    // }

  async submit() {
    try {
   
      
      if (!this.isCreate) {

        await this.nodeService.updateNode(
          this.existingNodeId,
          this.form.value.childId,
          this.form.value.parentId,
        ).toPromise();
        this.openSuccessDialog(this.isCreate);
      }else{
        await this.nodeService.createNode(
         // this.form.value.nodeId,
          this.form.value.ruleId,
          this.existingRulesetId,
          this.form.value.childId,
          this.form.value.parentId
        ).toPromise();
        this.openSuccessDialog(this.isCreate);
      }
    }
    catch (error) {

      this.openErrorDialog(error.message || 'An unexpected error occurred.');
    }
  }


  async checkNodeIdExists(nodeId: string): Promise<boolean> {
    try {

      const existingNodeResponse = await this.nodeService.getNodeByNodeId(nodeId).toPromise();


      if ('Resource retrieved successfully.' in existingNodeResponse) {
        const existingNode = existingNodeResponse['Resource retrieved successfully.'] as any;

        return existingNode !== null && existingNode.length > 0;
      }

      return false;
    } catch (error) {
      console.error("Error checking nodeId existence:", error);
      return false;
    }
  }

  openSuccessDialog(isCreate: boolean): void {
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      width: '250px',
      data: { isCreate: isCreate ,
        existingRulesetId: `${this.existingRulesetId}`,
        title: 'Node'
      },

    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['ada-access/auth-tools/policy-authoring/ruleset/update',this.existingRulesetId]);
    });
  }

  openErrorDialog(errorMessage: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '250px',
      data: { errorMessage: errorMessage },
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
}
